function initBsCarouselNav() {
  document.querySelectorAll(".section-resource-list").forEach(function (section) {
    if (section.dataset.bsNavReady) return;
    var nav = section.querySelector("[data-bs-nav]");
    var slides = section.querySelector("slideshow-slides");
    if (!nav || !slides) return;
    section.dataset.bsNavReady = "1";

    function step() {
      var c = slides.querySelector(".resource-list__slide");
      var w = c ? c.getBoundingClientRect().width : 240;
      return w + 16;
    }
    var prev = nav.querySelector("[data-bs-prev]");
    var next = nav.querySelector("[data-bs-next]");
    prev && prev.addEventListener("click", function () { slides.scrollBy({ left: -step(), behavior: "smooth" }); });
    next && next.addEventListener("click", function () { slides.scrollBy({ left: step(), behavior: "smooth" }); });
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initBsCarouselNav);
} else {
  initBsCarouselNav();
}
